// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LKVru6tfHUEDnEv7usX90"};